<template>
  <div class="cabinet-console-header-indicator">
    <div>{{ value }}</div>
    <div>{{ label }}</div>
  </div>
</template>

<script>
export default {
  name: "ConsoleHeaderIndicator",
  props: {
    'value': String,
    'label': String
  }
}
</script>

<style scoped>

</style>